/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const ContactSvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.50216 6.90499C8.41998 6.90499 9.09698 6.22878 9.09698 5.31016C9.09698 4.39154 8.41998 3.71533 7.50216 3.71533C6.58513 3.71533 5.90733 4.39154 5.90733 5.31016C5.90733 6.22878 6.58513 6.90499 7.50216 6.90499ZM7.50216 7.7024C5.74067 7.7024 4.3125 8.98783 4.3125 10.5731V10.8809H10.6918V10.5731C10.6918 8.98783 9.26364 7.7024 7.50216 7.7024Z" fill="currentColor"/>
    <path d="M13.0828 0.525879H1.91905C1.0395 0.525879 0.324219 1.24116 0.324219 2.12071V12.4871C0.324219 13.3666 1.0395 14.0819 1.91905 14.0819H5.1087L7.50094 16.4742L9.89318 14.0819H13.0828C13.9624 14.0819 14.6777 13.3666 14.6777 12.4871V2.12071C14.6777 1.24116 13.9624 0.525879 13.0828 0.525879ZM9.09577 12.4871L7.50094 14.0819L5.90612 12.4871H1.91905V2.12071H13.0828L13.0844 12.4871H9.09577Z" fill="currentColor"/>
  </svg>
);

export const ContactIcon = props => <Icon component={ContactSvg} {...props} />;
